import { CloseIcon, HelpCircleFilledIcon } from '@approvalmax/ui';
import { Box, Button, Grid, Text } from '@approvalmax/ui/src/components';
import { useSetAtom } from 'jotai';
import { memo, useCallback } from 'react';

import { messages } from './XeroReconnectWarning.messages';
import { xeroReconnectWarningVisibleState } from './XeroReconnectWarning.states';

export const XeroReconnectWarning = memo(() => {
    const setXeroReconnectWarningVisible = useSetAtom(xeroReconnectWarningVisibleState);

    const handleClose = useCallback(() => {
        setXeroReconnectWarningVisible(false);
    }, [setXeroReconnectWarningVisible]);

    return (
        <Box bordered radius='small' color='red20' borderColor='red40' spacing='12 16'>
            <Grid gap={8} gridTemplateColumns='max-content auto max-content' alignItems='center'>
                <HelpCircleFilledIcon size={16} />

                <Grid gap={4}>
                    <Text font='body' fontSize='small'>
                        {messages.xeroDoesntGrant}
                    </Text>

                    <Text font='label' fontSize='small'>
                        {messages.learnMore}
                    </Text>
                </Grid>

                <Button icon onClick={handleClose} variant='text' color='blue100'>
                    <CloseIcon size={16} />
                </Button>
            </Grid>
        </Box>
    );
});

XeroReconnectWarning.displayName = 'XeroReconnectWarning';
